export default __webpack_public_path__ + "static/19-1fb9cbd02a863a9b5997bc42c163c4f0.jpg";